module.exports = __webpack_public_path__ + "fonts/4174065.ttf";